module.exports = __webpack_public_path__ + "static/media/sophia-sig.3687e190.png";